"use client";

import { useContext } from "react";
import { QuickBooksContext } from "./provider";
import type { QuickBooksContextType } from "@/lib/types/quickbooks-unified";

export function useQuickBooks(): QuickBooksContextType {
  const context = useContext(QuickBooksContext);
  if (context === undefined) {
    throw new Error("useQuickBooks must be used within a QuickBooksProvider");
  }
  return context;
}

export function useQuickBooksConnection() {
  const { isConnected, tokens, error, refreshConnection } = useQuickBooks();
  return { isConnected, tokens, error, refreshConnection };
}

export function useQuickBooksCompany() {
  const { companyInfo, isLoadingCompanyInfo, companyInfoError, refreshCompanyInfo } =
    useQuickBooks();
  return { companyInfo, isLoadingCompanyInfo, companyInfoError, refreshCompanyInfo };
}

export function useQuickBooksMultiCompany() {
  const { connections, activeRealmId, activeConnection, connectionCount, setActiveRealm } =
    useQuickBooks();
  return { connections, activeRealmId, activeConnection, connectionCount, setActiveRealm };
}
